import { css } from 'styled-components';

export const container = css`
  margin: 60px auto;
`;
